/* eslint-disable @typescript-eslint/no-use-before-define */
import formatMonitor, { MediaFormat } from "./utils/formatMonitor";
import q from "qj/q";
import E from "qj/E";
import focusElement from "./utils/focusElement";
import throttle from "qj/throttle";

// ---------------------------------------------------------------------------

const htmlClass = document.documentElement.classList;
const header = q<HTMLElement>(".Layout__header");
let headerHeight = (header && header.clientHeight) || 0;
const skipLink = q<HTMLAnchorElement>('a.Layout__header__skiplink[href^="#"]');
const navElm = skipLink && q<HTMLElement>(skipLink.hash);

if (skipLink && navElm) {
  const closeButton = E(
    "button",
    {
      className: "Layout__nav__closebutton",
      "aria-label": "Close menu",
      onClick: () => {
        closeMenu();
      },
    },
    "Close menu"
  );

  let isOpen = false;
  let isActive = false;

  const activateMenu = () => {
    if (isActive) {
      return;
    }
    htmlClass.add("menu-is-active");
    skipLink.addEventListener("click", skipLinkHandler);
    // navElm.appendChild(closeButton);
    isActive = true;
  };

  const dectivateMenu = () => {
    if (!isActive) {
      return;
    }
    closeMenu();
    htmlClass.remove("menu-is-closed");
    htmlClass.remove("menu-is-active");
    skipLink.removeEventListener("click", skipLinkHandler);
    // closeButton && closeButton.remove();
    isActive = false;
  };

  const openMenu = () => {
    htmlClass.add("menu-is-open");
    htmlClass.remove("menu-is-closed");
    focusElement(navElm);
    isOpen = true;
  };

  const closeMenu = () => {
    htmlClass.add("menu-is-closed");
    htmlClass.remove("menu-is-open");
    focusElement(skipLink);
    isOpen = false;
  };

  const skipLinkHandler = (e: MouseEvent) => {
    e.preventDefault();
    if (isActive) {
      isOpen ? closeMenu() : openMenu();
    }
  };

  let lastOffs = 0;
  let updateLastOffset: ReturnType<typeof setTimeout>;
  let isFixed = false;
  let isShown = false;
  const delay = 50;
  const upLimit = 70; // px
  const downLimit = 50; // px
  const monitorScroll = function () {
    const yOffs = window.scrollY;
    const doFix = yOffs > headerHeight;
    clearTimeout(updateLastOffset);

    if (doFix !== isFixed) {
      isFixed = doFix;
      lastOffs = yOffs;
      htmlClass[isFixed ? "add" : "remove"]("is-header-fixed");
      htmlClass[isFixed ? "remove" : "add"]("is-header-unfixed");
      if (!isFixed) {
        htmlClass.remove("is-header-shown");
        htmlClass.remove("is-header-hidden");
        isShown = false;
      }
    }
    if (isFixed) {
      const delta = yOffs - lastOffs;
      let exceededLimit;
      if ((exceededLimit = delta > downLimit)) {
        // going down
        if (isShown) {
          htmlClass.remove("is-header-shown");
          htmlClass.add("is-header-hidden");
          isShown = false;
        }
      } else if ((exceededLimit = delta < -upLimit)) {
        // going up
        if (!isShown) {
          htmlClass.remove("is-header-hidden");
          htmlClass.add("is-header-shown");
          isShown = true;
        }
      }
      if (exceededLimit) {
        lastOffs = yOffs;
      } else {
        updateLastOffset = setTimeout(function () {
          lastOffs = yOffs;
        }, 1000);
      }
    }
  };

  window.addEventListener("scroll", throttle(monitorScroll, delay), false);

  const initMobileMenuCollapse = () => {
    const menuitem = document.querySelectorAll(
      ".MainMenu .MainMenu__items--level1 > .MainMenu__item"
    );
    menuitem.forEach((item) => {
      if (item.querySelectorAll("ul").length > 0) {
        if (
          item.classList.contains("MainMenu__item--current") == false &&
          item.classList.contains("MainMenu__item--parent") == false
        ) {
          item.classList.add("MainMenu__item--closed");
        } else {
          item.classList.add("MainMenu__item--open");
        }
      }
    });
  };

  const onFormatChange = (media: MediaFormat) => {
    if (media.becameHamburger) {
      activateMenu();
      headerHeight = (header && header.clientHeight) || 0;
      initMobileMenuCollapse();
    } else if (media.leftHamburger) {
      dectivateMenu();
      headerHeight = (header && header.clientHeight) || 0;
    }
  };
  formatMonitor.subscribe(onFormatChange);
}

// homepage: wrap newslist and tillkynningar
const html = document.querySelector("html");
if (html?.classList.contains("home")) {
  var newElm = document.createElement("div");
  newElm.classList.add("Layout__content--wrapper");
  Array.prototype.forEach.call(
    document.querySelectorAll(".home-news, .interesting"),
    function (c) {
      newElm.appendChild(c);
    }
  );
  document.querySelector(".Layout__content")?.appendChild(newElm);
}

// Menu
const initMenuCollapse = () => {
  let menuitem = document.querySelectorAll(
    ".MainMenu .MainMenu__items--level1 > .MainMenu__item"
  );

  menuitem.forEach((item) => {
    if (item.querySelectorAll("ul").length > 0) {
      const link = item.querySelector(".MainMenu__link");
      link?.addEventListener("click", (e) => {
        e.preventDefault();

        if (item.classList.contains("MainMenu__item--open")) {
          item.classList.remove("MainMenu__item--open");
        } else {
          for (var i = 0; i < menuitem.length; i++) {
            menuitem[i].classList.remove("MainMenu__item--open");
          }
          item.classList.add("MainMenu__item--open");
        }
        //item.classList.toggle("MainMenu__item--open");
      });
    }
  });
};
initMenuCollapse();
